import { ApiAuthUser } from "@incendium/api";
import UsersList from "Components/Users/UsersList";
import { useUsers } from "Hooks/useUsers";
import UserPage from "Pages/Account/UserPage";
import { useLayoutContext } from "Providers/LayoutProvider";
import { useLayoutEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";

function UsersPage() {
  const { setPageTitle } = useLayoutContext();
  const { users, setUsers } = useUsers();
  const history = useHistory();

  useLayoutEffect(() => {
    setPageTitle("User Management");
    return () => {
      setPageTitle("");
    };
  }, [setPageTitle]);

  const onSelect = (user: ApiAuthUser) => {
    history.push(`./users/${user.id}`);
  };

  const onNew = () => {
    history.push(`./users/new`);
  };

  return (
    <Switch>
      <Route exact path="/admin/users/:userId">
        <UserPage />
      </Route>
      <Route>
        <UsersList
          onEdit={onSelect}
          users={users}
          setUsers={setUsers}
          onNew={onNew}
          title="User Management"
        />
      </Route>
    </Switch>
  );
}

export default UsersPage;
